export function createMissingCategoryIdError({
  country,
  language,
  query,
  uuid,
  loyaltyTier
}) {
  const error = new Error("LoadCategoryDetailsError: Missing category ID");
  error.name = "MissingCategoryIdError";
  error.status = 404;
  error.statusText = "Not Found";
  error.type = "CLIENT_VALIDATION";
  error.severity = "error";
  error.module = "category/actions/loadCategoryDetails";
  error.timestamp = Date.now();

  error.country = country;
  error.language = language;
  error.query = JSON.stringify(query);
  error.uuid = uuid;
  error.loyaltyTier = loyaltyTier;
  error.isServer = typeof window === "undefined";
  error.userAgent =
    typeof navigator !== "undefined" ? navigator.userAgent : "server";
  error.href =
    typeof window !== "undefined" ? window.location.href : "server-side";
  error.referrer =
    typeof document !== "undefined" ? document.referrer : "unknown";
  error.akamaiBot = error.isServer
    ? global.req?.headers?.akamaibot ||
      global.req?.headers?.["akamai-bot"] ||
      null
    : null;

  error.queryKeys = Object.keys(query || {});
  error.hasEmptyQuery = !query || Object.keys(query).length === 0;
  error.cidType = typeof query?.cid;
  error.cidValue = query?.cid;

  return error;
}
